import { AmplitudeEvent } from "./AmplitudeEvent";

export class GoalListFilteredEvent extends AmplitudeEvent {
	constructor() {
		super();
		this.name = "Goal List Filter";
	}
}



// WEBPACK FOOTER //
// ./src/telemetry/GoalListFilteredEvent.js